// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"167":"detail","177":"home"}[chunkId] || chunkId) + "." + {"167":"e5def2e0","177":"bdd10d99","770":"e4bb8150"}[chunkId] + ".js";
};